import React, { useContext, useEffect, useState } from 'react'
import s from './ThisDay.module.scss'
import { GlobalSvgSelector } from '../../Assets/icons/global/GlobalSvgSelector'
import { Weather } from '../../store/types/types'
import moment from 'moment'
import 'moment/locale/ru';
import { CityContext } from '../../pages/Shared/Header/Header'
interface Props {
    weather: Weather;
}

export const ThisDay = ({weather}: Props) => {
    moment.locale('ru');       
    let time = moment().format('LT');
    const [currenttime,setCurrentTime] = useState(time)

    const updateTime = () =>{
        let time = moment().format('LT');
        setCurrentTime(time)
    }
    setInterval(updateTime,1000);

  return (
    <div className={s.this__day}>
        <div className={s.top__block}>
            <div className={s.top__block_wrapper}>
                <div className={s.this__temp}>{Math.floor(weather.main.temp)}</div>
                <div className={s.this__day_name}>Сегодня</div>
            </div>
            <GlobalSvgSelector id="sun"/>
        </div>
        <div className={s.bottom__block}>
            <div className={s.this__time}>
               Время: <span>{currenttime}</span>
            </div>
            <div className={s.this__city}>
                Город: <span>Липецк</span>
            </div>
        </div>
    </div>
  )
}